import { __exports as hash } from "../../../../../../_virtual/hash.js";
var hasRequiredHash;
function requireHash() {
  if (hasRequiredHash) return hash;
  hasRequiredHash = 1;
  Object.defineProperty(hash, "__esModule", { value: true });
  hash.hashCode = void 0;
  function hashCode(s) {
    let hash2 = 0;
    if (s.length === 0)
      return hash2;
    for (let i = 0; i < s.length; i++) {
      const chr = s.charCodeAt(i);
      hash2 = (hash2 << 5) - hash2 + chr;
      hash2 |= 0;
    }
    return hash2;
  }
  hash.hashCode = hashCode;
  return hash;
}
export {
  requireHash as __require
};
//# sourceMappingURL=hash.js.map
